import { css } from '@emotion/react';
import { theme, themeOld } from './theme';
import { rgba } from 'polished';
import { FlexStyle } from './FlexStyles';

export interface ButtonCircleStyle {
	green?: boolean;

	muted?: boolean;
	mutedInverse?: boolean;

	danger?: boolean;
	outline?: boolean;

	sizeSmall?: boolean;
	sizeExtraSmall?: boolean;

	active?: boolean;
}

export const ButtonCircleStyle = (
	{
		green,
		muted,
		mutedInverse,
		danger,
		outline,
		sizeSmall,
		sizeExtraSmall,
		active,
	}: ButtonCircleStyle = {
		green: false,
		muted: false,
		mutedInverse: false,
		danger: false,
		outline: false,
		sizeSmall: false,
		sizeExtraSmall: false,
		active: false,
	},
) => [
	FlexStyle({ centered: true }),
	css`
		width: 40px;
		height: 40px;

		${!!sizeSmall &&
		css`
			width: 36px;
			height: 36px;
		`}

		${!!sizeExtraSmall &&
		css`
			width: 24px;
			height: 24px;
		`}

		color: ${theme.color.text['300']};
		border-radius: 8px;
		border: 0;
		background: transparent;

		&:hover {
			color: ${theme.color.text['300']};
			background: ${theme.color.primary['50']};
		}

		${!!active &&
		css`
			color: ${themeOld.COLOR_BASE_GREEN};
			background: ${themeOld.COLOR_GREEN_LIGHTEN_45};

			&:hover {
				color: ${themeOld.COLOR_BASE_GREEN};
				background: ${themeOld.COLOR_GREEN_LIGHTEN_45};
			}
		`}

		// white muted
		${green &&
		css`
			background: ${themeOld.COLOR_BASE_GREEN};

			color: #fff;

			&:hover,
			&:focus {
				border-color: ${themeOld.COLOR_GREEN_LIGHTEN_2};
				background: ${themeOld.COLOR_GREEN_LIGHTEN_2};
				color: #fff;
			}

			&:active,
			&:disabled {
				background: ${themeOld.COLOR_GREEN_DARKEN_6};
				border-color: ${themeOld.COLOR_GREEN_DARKEN_6};
				color: #fff;
				cursor: default;
			}
		`}

		${muted &&
		css`
			color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_46};
		`}


		${mutedInverse &&
		css`
			color: ${rgba('#fff', 0.4)};

			&:hover {
				cursor: pointer;
				color: ${themeOld.COLOR_BASE_GREEN};
				background: ${rgba('#fff', 0.1)};
			}
		`};

		${outline &&
		css`
			border: 1px solid ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};

			&:hover {
				border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
			}

			&:active {
				border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_74};
			}
		`}

		${danger &&
		css`
			background: ${themeOld.COLOR_BASE_RED};

			color: #fff;

			&:hover {
				cursor: pointer;
				color: #fff;
				background: ${rgba('#fff', 0.3)};
			}
		`}

  &,
  &:hover,
  &:focus,
  &:active {
			transition: all 0.168s ease-in-out;
			outline: none;
			cursor: pointer;
		}
	`,
];
